import script from "./AdminDelete.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDelete.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__